import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { HowItWorks } from '../components/HowItWorks';
import { Services } from '../components/Services';
import { SpecialSessions } from '../components/SpecialSessions';
import { PaymentAndCancellation } from '../components/PaymentAndCancellation';
import { FinalCTA } from '../components/FinalCTA';
export function SesionesPage() {
  return <>
      <PageHeader eyebrow="Tres niveles · Un mismo método" title="Sesiones disponibles" subtitle="La profundidad que cada momento necesita." data-id="element-559" />
      <HowItWorks data-id="element-560" />
      <Services data-id="element-561" />
      <SpecialSessions data-id="element-562" />
      <PaymentAndCancellation data-id="element-563" />
      <FinalCTA data-id="element-564" />
    </>;
}